/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Contact_TitleInputs */

const he_seo_contact_title = /** @type {(inputs: Seo_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צור קשר - Pricedrop`)
};

const en_seo_contact_title = /** @type {(inputs: Seo_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Us - Pricedrop`)
};

/**
* | output |
* | --- |
* | "Contact Us - Pricedrop" |
*
* @param {Seo_Contact_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_contact_title = /** @type {((inputs?: Seo_Contact_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Contact_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_contact_title(inputs)
	return en_seo_contact_title(inputs)
});